module.exports = __webpack_public_path__ + "img/whatsapp.3de948c3.svg";